module.exports = __webpack_public_path__ + "static/img/16.3a1a869.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/16.png
// module id = yChg
// module chunks = 0